<template>
  <div>
    <div style="padding: 2rem 3rem">
      <div class="row">
        <div class="col-md-12">
          <h5 style="margin-bottom: 1.5rem">Add payment method</h5>
          <div style="padding: 2rem">
            <div
              class="payment_instrument_logos text-center"
              style="margin-bottom: 2rem"
            >
              <img alt="Visa" class="" src="/build/img/visa.png" />
              <img alt="MasterCard" class="" src="/build/img/mastercard.png" />
              <img alt="Discover" class="" src="/build/img/discover.png" />
              <img
                alt="American Express"
                class=""
                src="/build/img/american_express.png"
              />
              <img alt="JCB" class="" src="/build/img/jcb.png" />
            </div>
            <div>
              <div id="card-element"></div>
              <div id="card-errors" role="alert"></div>
            </div>
            <hr />
          </div>
          <h5 style="margin-bottom: 1.5rem">
            Others options of payment to add
          </h5>
          <div class="text-center">
            <a v-if="userAchAccess" href="/account/manage-ach">
              <button class="btn btn-default btn-block mt-4">
                Bank Account
              </button>
            </a>
            <!-- eslint-disable-next-line no-unused-vars -->
            <a
              v-if="
                userAchCreditAccess &&
                !userStripePaymentIntentAccess &&
                !hasUserAchCredit
              "
              href="/account/ach-credit-transfer"
            >
              <button class="btn btn-default btn-block mt-4">
                ACH Credit Transfer
              </button>
            </a>
            <!-- eslint-disable-next-line no-unused-vars -->
            <a
              v-if="
                userAchCreditAccess &&
                userStripePaymentIntentAccess &&
                !hasUserBankTransfer
              "
              href="/account/virtual-bank"
            >
              <button class="btn btn-default btn-block mt-4">
                Virtual Bank
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        background-color: #eeeeee;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
      "
    >
      <button
        type="button"
        class="btn btn-outline-primary"
        :disabled="submitting"
        @click="$emit('toggleAddPayment')"
      >
        Cancel
      </button>

      <inline-loading-indicator v-if="submitting"></inline-loading-indicator>
      <button
        v-else
        type="button"
        class="btn btn-primary"
        @click="handleSubmit"
      >
        Add card
      </button>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import store from "../../../../store/stores";
import InlineLoadingIndicator from "../../../InlineLoadingIndicator.vue";

export default {
  store,
  components: { InlineLoadingIndicator },
  data() {
    return {
      submitting: false,
      stripe: null,
      cardElement: null,
    };
  },
  computed: {
    ...mapGetters({
      billingAddress: "checkout/billingAddress",
      stripeKey: "checkout/stripeKey",
      stripeAPIs: "checkout/stripeAPIsConf",
      currency: "checkout/currency",
      userAchAccess: "checkout/userAchAccess",
      userAchCreditAccess: "checkout/userAchCreditAccess",
      userStripePaymentIntentAccess: "checkout/userStripePaymentIntentAccess",
      hasUserAchCredit: "checkout/hasUserAchCredit",
      hasUserBankTransfer: "checkout/hasUserBankTransfer",
    }),
  },
  created() {
    // eslint-disable-next-line no-undef
    this.stripe = Stripe(this.stripeKey);
  },
  mounted() {
    const elements = this.stripe.elements();

    const style = {
      base: {
        iconColor: "#d16c00",
        color: "#000000",
        fontWeight: 500,
        fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#d16c00",
        },
        "::placeholder": {
          color: "#d16c00",
        },
      },
      invalid: {
        iconColor: "#991900",
        color: "#991900",
      },
    };

    this.cardElement = elements.create("card", { style });
    this.cardElement.mount("#card-element");
    this.cardElement.addEventListener("change", ({ error }) => {
      const displayError = document.getElementById("card-errors");
      if (error) {
        displayError.textContent = error.message;
      } else {
        displayError.textContent = "";
      }
    });
  },
  methods: {
    handleSubmit() {
      this.submitting = true;
      /** At this point the only payment type we submit in this component is the credit_card type.
          Others types are added outside the stripe element. Then we only check for credit_card. */
      if (this.stripeAPIs.credit_card !== "payment_method") {
        return this.submitSource();
      }
      return this.submitPaymentMethod();
    },
    submitSource() {
      this.stripe
        // eslint-disable-next-line no-undef
        .createSource(this.cardElement, {
          type: "card",
          currency: this.currency,
          owner: {
            name: `${this.billingAddress.first_name} ${this.billingAddress.last_name}`,
            address: {
              line1: this.billingAddress.address,
              line2: this.billingAddress.address2,
              city: this.billingAddress.city,
              state: this.billingAddress.state,
              country: this.billingAddress.country,
              postal_code: this.billingAddress.zip,
            },
          },
          usage: "reusable",
        })
        .then((res) => {
          if (res.error) {
            swal.fire({
              title: "Uh oh..",
              type: "error",
              html: `<p>We are unable to validate your source!</p>`,
            });

            // eslint-disable-next-line no-useless-return
            return;
          }
          this.$emit("toggleAddPayment");

          // eslint-disable-next-line consistent-return
          return this.$store.dispatch(
            "checkout/createCardFromNewPaymentElement",
            res.source
          );
        })
        // eslint-disable-next-line no-unused-vars
        .catch((e) => {
          swal.fire({
            title: "Uh oh..",
            type: "error",
            html: `<p>We are unable to validate your source!</p>`,
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submitPaymentMethod() {
      this.stripe
        // eslint-disable-next-line no-undef
        .createPaymentMethod(
          {
            type: "card",
            card: this.cardElement,
            billing_details: {
              name: `${this.billingAddress.first_name} ${this.billingAddress.last_name}`,
              address: {
                line1: this.billingAddress.address,
                line2: this.billingAddress.address2,
                city: this.billingAddress.city,
                state: this.billingAddress.state,
                country: this.billingAddress.country,
                postal_code: this.billingAddress.zip,
              },
            },
          },
          {
            currency: this.currency,
          }
        )
        .then((res) => {
          if (res.error) {
            swal.fire({
              title: "Uh oh..",
              type: "error",
              html: `<p>We are unable to validate your payment method!</p>`,
            });

            // eslint-disable-next-line no-useless-return
            return;
          }
          this.$emit("toggleAddPayment");

          // eslint-disable-next-line consistent-return
          return this.$store.dispatch(
            "checkout/createCardFromNewPaymentElement",
            res.paymentMethod
          );
        })
        // eslint-disable-next-line no-unused-vars
        .catch((e) => {
          swal.fire({
            title: "Uh oh..",
            type: "error",
            html: `<p>We are unable to validate your payment method!</p>`,
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped>
.add-ach-link:hover {
  text-decoration: underline;
}

.btn-outline-primary {
  border: 1px solid #d16c00 !important;
  color: #d16c00;
  background: none;
}

.btn-outline-primary:hover {
  border: 1px solid #d16c00;
  background: #f5e1cc;
}
</style>
